// extracted by mini-css-extract-plugin
var _1 = "CollapseControlled_border__08443";
var _2 = "CollapseControlled_content__59844";
var _3 = "CollapseControlled_contentWrapper__ba4b6";
var _4 = "CollapseControlled_defaultTitle__20f45";
var _5 = "CollapseControlled_defaultTitleContent__2a0e5";
var _6 = "CollapseControlled_ghost__308a0";
var _7 = "CollapseControlled_root__1699a";
var _8 = "CollapseControlled_title__60c95";
export { _1 as "border", _2 as "content", _3 as "contentWrapper", _4 as "defaultTitle", _5 as "defaultTitleContent", _6 as "ghost", _7 as "root", _8 as "title" }
